import { render, staticRenderFns } from "./calcuteFrame.vue?vue&type=template&id=515bda7c&scoped=true&"
import script from "./calcuteFrame.vue?vue&type=script&lang=js&"
export * from "./calcuteFrame.vue?vue&type=script&lang=js&"
import style0 from "./calcuteFrame.vue?vue&type=style&index=0&id=515bda7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bda7c",
  null
  
)

export default component.exports